import { captureMessage, Severity } from '@sentry/nextjs';
import { TAppEnvironmentSettings } from '../environment/environment.types';
import { getAppEnvironmentSettings } from '../environment/environment';
import {
    TMessagesParameters,
    TThread,
    TThreadParameters,
    TThreadsResponse,
} from '../configuration/common.types';

const headers = {
    'AzureAuthentication': '1',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache': 'no-cache',
    'X-Requested-With': 'XMLHttpRequest',
};

const environment: Readonly<TAppEnvironmentSettings & TAppEnvironmentSettings> =
    getAppEnvironmentSettings();
function getFilterDate(): string {
    const date = new Date();
    date.setDate(date.getDate() - 90);
    return date.toISOString();
}

export const getThreads = async ({
    limit,
    cursor,
    noFilter,
}: TThreadParameters) => {
    const parameters = new URLSearchParams();

    if (limit !== undefined) {
        parameters.append('limit', limit.toString());
    } else {
        parameters.append('limit', '50'); // Default limit
    }

    if (cursor) {
        parameters.append('cursor', cursor);
    }

    if (!noFilter) {
        parameters.append('fromDate', getFilterDate());
    }
    const response = await fetch(
        `${
            environment.baseApiUrl
        }/messaging-api/v2/threads?${parameters.toString()}`,
        {
            headers,
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
        }
    );

    if (!response.ok) {
        const errorMessage = 'Could not get threads data.';
        const severityLevel =
            response.status === 401 ? Severity.Warning : Severity.Error;
        captureMessage(errorMessage, {
            extra: {
                response,
            },
            level: severityLevel,
        });
        throw new Error(errorMessage);
    }

    const threads: TThreadsResponse = await response.json();
    return threads;
};

export const getThreadByThreadId = async ({
    threadId,
}: Partial<TMessagesParameters>) => {
    const response = await fetch(
        `${environment.baseApiUrl}/messaging-api/v2/threads/${threadId}`,
        {
            headers,
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
        }
    );

    if (!response.ok) {
        const errorMessage = 'Could not get thread by thread id.';
        const severityLevel =
            response.status === 401 ? Severity.Warning : Severity.Error;
        captureMessage(errorMessage, {
            extra: {
                response,
            },
            level: severityLevel,
        });
        throw new Error(errorMessage);
    }

    const thread: TThread = await response.json();
    return thread;
};
